/* eslint-disable @typescript-eslint/ban-types */
import { useEffect } from 'react';

export function usePlaidLinkShouldOpen(
  ready: boolean,
  open: Function,
  receivedRedirectUri: string | undefined
) {
  useEffect(() => {
    if (ready && receivedRedirectUri) {
      open();
    }
  }, [ready, open, receivedRedirectUri]);
}
